// export const environment = {
//   production: false,
//   API_URL: 'http://localhost:8080/cu-communication-service-dev/api-v2/eyeton',
//   SOCKET_URL: 'https://dev.sensor.auton.in/',
// };
export const environment = {
  production: false,
  API_URL:
    'https://sensor.auton.in/cu-communication-service/api-v2/eyeton',
  SOCKET_URL: 'https://sensor.auton.in/',
  // ── Payload encryption ────────────────────────────────────────────────
  // `enabled: true`  → request bodies and responses travel as AES-256-GCM
  //                    ciphertext, so payloads do not show in the Network tab.
  // `enabled: false` → plaintext, for debugging. No backend change needed:
  //                    the server only decrypts requests carrying `X-Enc` and
  //                    mirrors whatever the client did.
  //
  // `key` is base64 of 32 raw bytes and MUST equal the backend's
  // PAYLOAD_ENCRYPTION_KEY. Generate with: openssl rand -base64 32
  //
  // ⚠️ This key ships inside the JS bundle — unavoidable for browser-side
  // crypto. It stops payload snooping on the wire and in DevTools' Network
  // tab; it does not stop a determined user reading values in the debugger.
  // Never treat it as an access control; that stays with the backend's
  // @PreAuthorize checks.
  encryption: {
    enabled: true,
    key: 'A9Isz3uvqhUSGk2JlclJ2fSM7kOZ2Fl0FgVVuyDQWi8=',
  },
};

